import { SnackbarVariant } from '@eas/common-web';
import { MessageType } from './message-type';

const Common: MessageType<'SUCCESS' | 'ERROR' | 'VALIDATION_ERROR'> = {
  SUCCESS: ['Akce byla úspěšně vykonána', SnackbarVariant.SUCCESS],
  ERROR: [
    'Došlo k neočekávané chybě, kontaktujte administrátora.',
    SnackbarVariant.ERROR,
  ],
  VALIDATION_ERROR: ['Ve formuláři se nacházejí chyby', SnackbarVariant.ERROR],
};

export default Common;
